import { StyleSheet } from "react-native";
import { Dimensions } from "react-native";

export const styles = StyleSheet.create({
  modal: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "black",
  },
  modalContainer: { alignSelf: "center" },
  controlGroups: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-around",
  },
  cameraContainer: {
    flex: 1,
    flexDirection: "row",
  },
  controls: {
    flexDirection: "row",
    width: "100%",
    alignSelf: "flex-end",
    alignItems: "center",
  },
  imagePreview: {
    backgroundColor: "black",
    alignSelf: "center",
    justifyContent: "center",
    width: Dimensions.get("window").width * 0.8,
    height: Dimensions.get("window").height * 0.8,
  },
  cameraControl: {
    alignItems: "center",
  },
  cameraControlText: {
    color: "white",
    fontSize: 10,
  },
});
